// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"indent-left"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 5H21M9 12H21M3 19H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M4.76777 10.2319L3 11.9997L4.76777 13.7675","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const IndentLeftIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'indent-left',
    ref,
    icon: element,
  },
));

IndentLeftIcon.displayName = 'IndentLeftIcon';

export default IndentLeftIcon;
